
















































































































































































































import GenericEdit from "@/core/Generics/GenericEdit";
import { Component, Watch } from "vue-property-decorator";
import User from "../../models/security/user.model";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import AvatarCropper from "vue-avatar-cropper";
import { IdentificationType } from "@/enums/IdentificationType";
import Helpers from "../../helpers/helper";
@Component({
  components: { DatePickerComponent, AvatarCropper }
})
export default class ProfileEdit extends GenericEdit<User> {
  loadingSaving = false;
messageError = "";
  constructor() {
    super();
    this.controller = "User";
    this.model = new User();
  }

  get user() {
    return this.$store.state.user;
  }
  @Watch("model.identificationType")
  onIdentificationTypeChange(){
    if(this.model.identificationType == 1){
      this.messageError = '';
    }
  }
  cleanError(){
  this.messageError ='';

  
}
 validateIdenticaction(event: any) {
    let c = event.target.value.split("");
    let v = [1, 2, 1, 2, 1, 2, 1, 2, 1, 2];
    var result = 0;
    var ar;
    let result1 = "";
    var up;
    var oc;
    for (var i = 0; i < 10; i++) {
      up = c[i] * v[i];
      let ab = up;
      if (ab >= 10) {
        oc = ab
          .toString()
          .split("")
          .map((x) => parseInt(x))
          .reduce((x, y) => x + y);
      } else {
        oc = ab;
      }
      result = result + parseFloat(oc);
    }

    let dp = result;
    var ac1 = dp.toString().split("")[0] + "0";
    let ac = parseInt(ac1);
    let uj = (ac / 10) * 10;
    if (uj < dp) {
      dp = uj + 10 - dp;
    }

    if (c[10] == dp) {
     
    } else {
      this.$buefy.toast.open({
        message: "La Cédula es incorrecta",
        queue: false,
        duration: 4000,
        type: "is-danger",
        position: "is-top-right",
      });
     this.messageError = 'Favor introducir una Cédula valida';

    }
  }

  protected async edit() {
    if(this.model)
    try {
      this.saving = true;
      if(this.messageError || !this.model.identification){
        this.validateIdenticaction(event);
        return;
      }
      var result = await this.repository.update(this.user.id, this.model);
      this.saving = false;
      this.$emit("edit", result);
      this.clean();
      this.operationSuccess();

      this.confirmedCancel();
    } catch (error) {
      var errors: any[] = [];
      if (Object.prototype.toString.call(error.data) === "[object String]") {
        errors.push(error.data);
      } else if (error.data && error.data.length > 0) {
        var errorMessages = error.data as any[];
        errorMessages.forEach(x => errors.push(x.errorMessage));
      } else {
        errors.push(error);
      }
      console.log(errors);
      this.operationFailedErrors(errors);
    } finally {
      this.saving = false;
    }
  }

  @Watch("$store.state.defaultCountry")
  onDefaultCountry(country: any) {
    if (!this.model.user.countryId && this.$store.state.defaultCountry) {
      this.model.user.countryId = this.$store.state.defaultCountry.id;
    }
  }

  protected async getData() {
    try {
      if (this.modelToEdit && !this.loadFromAPI)
        this.model = this.map<User>(this.modelToEdit);
      else {
        this.loading = true;
        this.model = await this.repository.byId(this.user.id, this.include);
      }

      this.modelInit = this.map<User>(this.model);

      if (!this.model.identification) {
        this.model.identificationType = IdentificationType.IDENTIFICATIONCARD;
      }

      if (this.model.dob) {
        this.model.dob = new Date(this.model.dob) as any;
      }
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.loading = false;
    }
  }

  protected confirmedCancel() {
    this.model = this.map<User>(this.modelInit);
    this.$router.push(`${this.$router.currentRoute.path.split("/edit")[0]}`);
  }
}
